module.exports = __webpack_public_path__ + "static/media/supervisorchat.bf5c206c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/supervisorchat.svg
// module id = 1839
// module chunks = 0